import { H2 } from "@datapay-by-datacom/design-system";
import { UserManagementNavTabs, UserTable } from "../components";

export function UserManagementScreen() {
  return (
    <div>
      <H2>User Management</H2>
      <UserManagementNavTabs />
      <UserTable />
    </div>
  );
}
